module.exports = __webpack_public_path__ + "assets/img/background.jpg?hash=e82f6e9d4e5d877c7218a1530ff5567b";